module.exports = __webpack_public_path__ + "static/media/monster-06.1c97707a.png";